'use strict';
const ClipboardModel = require('../models/clipboard-model'),
	ClipboardConverter = require('@mindmup/mapjs-core/src/content/clipboard-converter'),
	plaintextToMindmupArray = require('../models/plaintext-to-mindmup-array'),
	htmlToMindmupArray = require('../widgets/html-to-mindmup-array'),
	mmWidgets = require('../widgets/mm-widgets');

module.exports = function clipboardStart(mapModel, mapThemeModel, clipboardModelConfiguration, navigatorShim) {
	if (!mapModel || !mapThemeModel || !navigatorShim || !clipboardModelConfiguration) {
		throw new Error('invalid-args');
	}
	const clipboardModel = new ClipboardModel(mapModel, mapThemeModel, clipboardModelConfiguration),
		clipboardConverter = new ClipboardConverter('application/vnd.mindmup', {
			'text/plain': plaintextToMindmupArray,
			'text/html': htmlToMindmupArray
		}),
		initialiseWidgets = function () {
			require('../widgets/context-disabler-widget');
			mmWidgets('[data-mm-clipboard-context]').contextDisablerWidget(clipboardModel, 'context', 'data-mm-clipboard-context');
			if (navigatorShim.isSafari()) {
				mmWidgets('[data-mm-clipboard-action]').remove();
			} else {
				require('../widgets/clipboard-action-widget');
				mmWidgets('[data-mm-clipboard-action]').clipboardActionWidget();
			}

			require('../widgets/clipboard-widget');
			mmWidgets(document).clipboardWidget(clipboardModel, clipboardConverter);
		};
	return {clipboardModel, clipboardConverter, initialiseWidgets};
};
